import React from 'react';
import { useTranslation } from 'react-i18next';
import ReportForm from '../ReportForm';

const FollowUpInvestorProfileReport:React.FC = () => {
    const { t } = useTranslation();

    return <ReportForm title={t('reports.FollowUpInvestorProfile.title')} APIName="getFollowUpInvestorProfileReport" savedFileName={t('reports.FollowUpInvestorProfile.title')} />;
};

export default FollowUpInvestorProfileReport;
